export default "__VITE_ASSET__0jMULGnc__"